import { Spinner } from "../../../components/Loading/Spinner";
import AllEntitiesPieCharts from "../../../components/Table/Dashboard/AllEntities/AllEntitiesPieCharts";
import CustomStackedBarChart from "../../../components/Table/Dashboard/AllEntities/CustomStackedBarChart";
import SelectTypeOfDashboard from "../../../components/Table/Dashboard/SelectTypeOfDashboard";
import { useAllSuborgsDashboard } from "../../../context/SuperAdmin/DashboardContexts/AllSuborgs";

const AllSuborgsDashboard = () => {
  const {
    isLoadingTotalCredits,
    totalCredits,
    totalCreditsFilters,
    handleToggleCredit,
  } = useAllSuborgsDashboard();

  if (isLoadingTotalCredits) {
    return <Spinner msg="Cargando por favor espere..." />;
  }
  return (
    <SelectTypeOfDashboard routeValue="suborganizations">
      <AllEntitiesPieCharts
        credits={totalCredits}
        title="Total suborganizaciones"
        label="suborganizacion"
      />
      <CustomStackedBarChart
        credits={totalCredits}
        label="suborganizacion"
        id="id_suborganizacion"
        totalCreditsFilters={totalCreditsFilters}
        handleToggleCredit={handleToggleCredit}
      />
    </SelectTypeOfDashboard>
  );
};

export default AllSuborgsDashboard;
